import { AfterViewInit, Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ItemEntryComponent } from '../item-entry/item-entry.component'
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { APIService, myCurrency } from '../../api.service';
import { ProductDetailComponent } from '../product-detail/product-detail.component'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectStoreComponent } from '../select-store/select-store.component';
import { TransactionComponent } from '../transaction/transaction.component';
import { CommonService } from '../../services/common.service';
import * as XLSX from 'xlsx';
import { debug } from 'console';
import { Observable } from 'rxjs';
import { from, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CategoriesComponent } from '../../inventory/categories/categories.component'
import { ImportItemsComponent } from '../import-items/import-items.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { BatchSelectionComponent } from '../batch-selection/batch-selection.component';
import { DataService} from 'src/app/services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ModuleTrainingComponent } from '../../module-training/module-training.component';

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.scss']
})
export class StockComponent implements AfterViewInit, OnInit {

  //@ViewChild(MatPaginator) paginator! : MatPaginator;
  @ViewChild('epltable', { static: false }) epltable!: ElementRef;
 
  //@ViewChild(MatSort) sort: MatSort | any;

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild('inputStockSearch') inputStockSearch!: ElementRef<HTMLInputElement>;
  @ViewChild('qtyEdit') qtyEdit!: any;
  @ViewChild('qtyStrBatch') qtyStrBatch!: any;

  categoryCtrl = new FormControl();
  subCategoryCtrl = new FormControl();

  filteredCategory!: Observable<category[]>;
  filteredsubCategoryList!: Observable<subCategory[]>;
  
  ValnMethod: number = -1;
  SCN : any;
  @Input() mdlRef: any;
 
  ItemCategories : any = [];
  myCurrency: any = myCurrency();
 
  changingValue: Subject<boolean> = new Subject();
  changingHeadValue: Subject<boolean> = new Subject();

  isWeb: boolean = true;
  isShowStock: boolean = false;
  isdataFilter: boolean = false
  allStoreRights: boolean = true;
  isRateView: boolean = false;
  fromItemEntry: any = '';
  batchList : any = [];
  isBatchShow: boolean = false;
  isRecoBatchDivShow: boolean = false;
  totalStkQty:  number = 0;
  totalStkUnit:  number = 0;
  itemPrcn:  number = 0;
  batchTotalQty : any = 0;
  storeTotalQty : any = 0;
  currItemID : number = 0;
  tempStrQty : any = [];
  oldBatchList : any = [];
  newBatchList : any = [];
  isEnableBatches : boolean = false;
  ERP_Agn: Array<any> = [];
  resetBatchData: any = [];
  selected: any = {
    imp: 3,
    stockType: 1,
    isActive: 0,
  };
  show: any = {
    search: false,
    filters: false,
  };
  showUpgrade: any = false;
  currentStock: number = 0;
  maxStock: number = 0;
  showLearningMaterial: boolean = false;
  showOnBoarding: boolean = false;
  tmpstrQty: any = [];
  cntTotalItems: number = 0;
  showItemList: boolean = true;
  selectedStatus: string = 'all'; 
  fullInvRights: boolean = false;
  changeType: string = '';

  constructor(private modalService: NgbModal, private apiService: APIService, public CmnService: CommonService,public commonFun: CommonService,private SpinnerService: NgxSpinnerService, private dataSer: DataService, private route: ActivatedRoute, private router: Router) {
   
    let agencyData = this.apiService.getCookie("M");
    let tagData = this.apiService.getCookie("ERP_Cfg");
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    this.right = this.apiService.getCookie("J");
    if(this.right){
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function(o: any){ return o.UserID == ownUserID })[0];
      
      if(!this.right.Inv && !this.right.InvCfg && !this.right.InvMstrs && !this.right.InvRpts && !this.right.InvXns){
       window.location.href = "../../main.html#/home";
        return;
      }
      if (this.right.InvRateView.toString()  != "undefined") {
        this.isRateView = this.right.InvRateView
      }
    }

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
      if (this.ERP_Agn.length > 0) {
        this.isEnableBatches = this.ERP_Agn[0].EnblBatches;
      }
    }
    if (tagData) {
      this.tagData = JSON.parse(tagData)
      // if(this.tagData[0].ItemCategories){
      //   this.categoryCtrl = JSON.parse(this.tagData[0].ItemCategories)
      // }
    }

    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      var PremiumTillDT = this.agencyData[0].PremiumTillDT;
      // if (new Date(PremiumTillDT) < new Date() || !PremiumTillDT || PremiumTillDT == null) {
      //   window.location.href = "main.html#/home";
      //   return;
      // }  
      if (this.apiService.checkIsPremiumOrTrial() == false){
        if (this.apiService.fn_isLiveURL() == true)
        {
          window.location.href = "https://biziverse.com/main.html#/home";
          return;
        }
        else{
          window.location.href = "main.html#/home";
          return;
        }    
      } 
    }

    this.isWeb = this.apiService.apiCheckWeb();

    this.tag = this.tagData[0].ItemTags.split(',');
    this.tag = this.tag.filter((a: any) => String(a).trim() != '');
    this.tag = [... new Set(this.tag.map((x : any) => x))];
    this.tag = this.tag.sort((a: any, b: any) => a.localeCompare(b));

    this.getAllConfig();

    let getParm =  this.commonFun.GetParam("FR");
    if(getParm == 'Doc'){
     this.open(getParm);
    }
    else{
      //nothing
    } 
  }

  ngOnInit(): void {
    let openImport: any = this.CmnService.GetParam('im');
    if (openImport == 1) {
      this.importItems('itemimport');   
      this.router.navigateByUrl('/Stock', {replaceUrl:true});
    } 
    
    this.loadFilters();
    
    let itemPriority = this.CmnService.GetParam('p');
    if (itemPriority) this.selected.imp = Number(itemPriority);
    let stockType = this.CmnService.GetParam('s');
    if (stockType) this.selected.stockType = Number(stockType);
    //Change valuationmethod in valuation Number...
    var ValnMethoddata = this.apiService.getCookie("ERP_Cfg");
    if (ValnMethoddata) {
      let valuMethod = JSON.parse(ValnMethoddata);     
      this.ValnMethod = valuMethod[0].ValnMethod;
    }
    if (this.agencyData.length > 0 && this.jarvisData.length > 0) {
      this.isAdmin = (this.agencyData[0].AdminUserID == this.jarvisData[0].UserID) ? true : false;
    }

    this.fullInvRights = (this.isAdmin || (this.right.Inv && this.right.InvCfg && this.right.InvMstrs && this.right.InvRpts && this.right.InvXns));
    //alert("This feature is under development expected release in April 2021.");
    var erpCnts = this.apiService.getCookie("ERP_Cnts");
    if (erpCnts) {
      let parsedErpCnts = JSON.parse(erpCnts);     
      this.currentStock = parsedErpCnts[0].CntStockItems ? parsedErpCnts[0].CntStockItems : 0;
      this.maxStock = parsedErpCnts[0].CntMaxStockItems ? parsedErpCnts[0].CntMaxStockItems : 0; 

      if (this.currentStock && this.maxStock && this.maxStock !== -1) { //Suggest Upgrade if more than 50% used
        let halfQuota = this.maxStock/2
        if (this.currentStock >= halfQuota) {
          this.showUpgrade = true;
        }   
      } 
    }

    this.ItemNameFilter.valueChanges
      .subscribe(
        NameFilter => {
          this.filterValues.ItemName = NameFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.ItemCodeFilter.valueChanges
      .subscribe(
        OpBalFiltert => {
          this.filterValues.ItemCode = OpBalFiltert;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.CategoryFilter.valueChanges
      .subscribe(
        CrAmtFilter => {
          this.filterValues.Category = CrAmtFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.ImpFilter.valueChanges
      .subscribe(
        ImpFilter => {
          this.filterValues.Imp = ImpFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.CurrQtyFilter.valueChanges
      .subscribe(
        DbAmtFilter => {
          this.filterValues.CurrQty = DbAmtFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.SKUFilter.valueChanges
      .subscribe(
        CloBalFiltert => {
          this.filterValues.SKU = CloBalFiltert;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.StockValueFilter.valueChanges
      .subscribe(
        CloBalFiltert => {
          this.filterValues.StockValue = CloBalFiltert;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.DefStockRateFilter.valueChanges
      .subscribe(
        CloBalFiltert => {
          this.filterValues.DefStockRate = CloBalFiltert;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

      this.isShowStock = this.apiService.checkFeatureAccess('Stock');
      if(!this.isShowStock){
        window.location.href = "https://biziverse.com/main.html#/home";
      }

      this.showLearningMaterial = this.CmnService.checkShowLearningMaterial();
      this.showOnBoarding = this.CmnService.checkShowOnBoarding();
  }

  // openBatchSelectionMdl(content: any) {
  //   this.modalReference = this.modalService.open(BatchSelectionComponent, { windowClass : "BatchSelection", backdrop: 'static', keyboard: false});
  //   this.modalReference.componentInstance.mdlRef = this.modalReference;
  // }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;

    this.route.queryParams.subscribe(params => {
      if (params['o'] == '1') {
        setTimeout(() => {
          this.open('');
        }, 100);
      }

      if (params['i'] == '1') {
        setTimeout(() => {
          this.importItems('itemimport');
        }, 100);
      }

      if (params['in'] == '1') {
        setTimeout(() => {
          this.openTransaction(1);
        }, 100);
      }

      if (params['out'] == '1') {
        setTimeout(() => {
          this.openTransaction(0);
        }, 100);
      }
    });
  }

  subCategoryList: subCategory[] = [];
  categories: category[] = [];
 
  data: any = {
    categoryID: '0',
    subCategory: '',
    SubCategoryID: '0',
    category: '',
  }



 //auto complete category
 private _filterCategory(value: string): category[] {
  const filterValue = value.toLowerCase();
  return this.categories.filter(state => state.cnm.toLowerCase().indexOf(filterValue) === 0);
}

//auto complete subcategory
private _filterSubcategory(value: string): subCategory[] {
  const filterValue = value.toLowerCase();
  return this.subCategoryList.filter(state => state.snm.toLowerCase().indexOf(filterValue) === 0);
}

  totalValue: any = 0;
  filter: any = 0;
  search: string = '';
  ItemNameFilter = new FormControl('');
  ItemCodeFilter = new FormControl('');
  CategoryFilter = new FormControl('');
  ImpFilter = new FormControl('');
  CurrQtyFilter = new FormControl('');
  SKUFilter = new FormControl('');
  StockValueFilter = new FormControl('');
  DefStockRateFilter = new FormControl('');
  jarvisData: any = [];
  agencyData: any = [];
  tagData: any = [];
  tag: any = [];
  selectedTags: any = [];
  itemData: any = [];
  //  dataSource = new MatTableDataSource();
  dataSource: any = [];

  displayedColumns: string[] = ['ItemName', 'ItemCode', 'Imp', 'SCN', 'CurrQty', 'SKU', 'DefStockRate', 'TotalValue', 'Actions']; // 'StockValue',
  Items: any = [];
  copyItems: any = [];
  IncludeZeroqtyItms: any = [];
  depletedItems: any = false;
  zeroQtyItems: any = false;
  storeList: any = [];
  cntAllStores: any = 0;
  UnitList: any = [];
  hsnList: any = [];
  // categories: any = [];
  ItemID: any = 0
  storeId: any = 0
  storeName: any = 'All Stores';
  selectedStoreQty: any = [];
  itemName: any = '';
  activeItems: any = false;
  inactiveItems: any = false;

  filterValues = {
    ItemName: '',
    ItemCode: '',
    Category: '',
    CurrQty: '',
    Imp: '',
    SKU: '',
    StockValue: '',
    DefStockRate: ''
  };

  itemTag = {
    search: ''
  };
  exportToExcel: any = [];
  right: any;
  isAdmin: boolean = false;

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
        , base64 = function (s:any) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function (s:any, c:any) { return s.replace(/{(\w+)}/g, function (m:any, p:any) { return c[p]; }) }

    return function (table: any, name : string, fileName:any) {
        if (!table.nodeType) table = table
        var ctx = { worksheet: name || 'Worksheet', table: table }
        //window.location.href = uri + base64(format(template, ctx))
        var link = document.createElement("a");
        link.download = fileName || 'download.xls';
        link.href = uri + base64(format(template, ctx));
        link.click();
    }
  })()

  // createFilter(): (data: any, filter: string) => boolean {
  //   let filterFunction = function (data: any, filter: any): boolean {
  //     let searchTerms = JSON.parse(filter);
  //     return data.ItemName.toLowerCase().indexOf(searchTerms.Name) !== -1
  //       && data.ItemCode.toString().toLowerCase().indexOf(searchTerms.OpBal) !== -1
  //       && data.Category.toString().toLowerCase().indexOf(searchTerms.CrAmt) !== -1
  //       && data.CurrQty.toString().toLowerCase().indexOf(searchTerms.DbAmt) !== -1
  //       && data.SKU.toString().toLowerCase().indexOf(searchTerms.CloBal) !== -1
  //       && data.StockValue.toString().toLowerCase().indexOf(searchTerms.DbAmt) !== -1
  //       && data.DefStockRate.toString().toLowerCase().indexOf(searchTerms.CloBal) !== -1;

  //   }
  //   return filterFunction;
  // }

  //modal open
  closeResult: any;
  modalReference: any;

  selectedCatSubCat : any = [];

  open(content: any) {
    this.modalReference = this.modalService.open(ItemEntryComponent, { windowClass: 'modal-item-Entry', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.fromItemEntry = true;
    this.modalReference.result.then((result: any) => {
      if (result && result.action == 'Done') {
        let tmpERP_Cfg = this.apiService.getCookie("ERP_Cfg");
        if(tmpERP_Cfg){
          this.tagData =  JSON.parse(tmpERP_Cfg);
          if(this.tagData[0].ItemCategories){
            this.categories = JSON.parse(this.tagData[0].ItemCategories)
          }
        }
        // Item was added - use provided changeType or default to UPDATE
        this.changeType = result.changeType || 'UPDTPKG';
        this.getData();
        let itemID = JSON.parse(result.obj.updatePackage);
        let obj = {
          ItemID: itemID.Table[0].ItemID,
          IsMade: result.IsMade,
        }
        this.openItemEidt("", obj);
      }
    })
    this.batchList = [];
    this.dataSer.updateBathesData(this.batchList)
  }

  openItemEidt(content: any, obj: any) {
    // this.ItemID = obj
    this.modalReference = this.modalService.open(ProductDetailComponent, { windowClass: obj.IsMade ? 'modal-item-Edit' : 'modal-item-EditOne', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.ItemID = obj.ItemID;
    this.modalReference.componentInstance.stockItems = this.IncludeZeroqtyItms;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.stockCmp = this;

    this.modalReference.result.then((result: any) => {
        if (result && result.action == 'Done') {
          let tmpERP_Cfg = this.apiService.getCookie("ERP_Cfg");
          if(tmpERP_Cfg){
            this.tagData =  JSON.parse(tmpERP_Cfg);
            if (this.tagData[0].ItemCategories) {
              this.categories = JSON.parse(this.tagData[0].ItemCategories)
            }
            if (this.tagData[0].ItemTags) {
              let tag = this.tagData[0].ItemTags.split(',');
              tag = tag.filter((a: any) => String(a).trim() != '');
              tag = [... new Set(tag.map((x : any) => x))];
              tag = tag.sort((a: any, b: any) => a.localeCompare(b));
              this.tag = tag;
            }
          }
          // Item was edited - use provided changeType or default to UPDATE
          this.changeType = result.changeType || 'UPDTPKG';
          this.getData();
      }
    })
  }

  //filter
  typeFilter = (obj: any) => {
    var copyItems = this.IncludeZeroqtyItms; //this.copyItems
    var tempItem = [];
    this.filter = obj;
    
    if (obj == 0) {
      tempItem = copyItems; //this.copyItems;
    }
    else if (obj == 1) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 1);
    }
    else if (obj == 2) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 2);
    }
    else if (obj == 3) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 3);
    }
    else if (obj == 4) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 4);
    }
    else if (obj == 5) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 5);
    }
    if(obj == 6) {
      if(this.selected.imp == 3){
        tempItem = copyItems        
      } else {
        tempItem = copyItems.filter((item: any) => item.Imp == this.selected.imp)
      }
    }

    //If wiothout zero qty
    if (this.zeroQtyItems == false && this.depletedItems == false){
      tempItem = tempItem.filter((x: any) => x.CurrQty > 0);
    }

    //Deplited Filter
    if (this.depletedItems == true){
      tempItem = tempItem.filter((x: any) => (Number(x.CurrQty) < x.MinStockQty));
    }

    //Category Filter
    if(this.data.categoryID > 0)
    {
      let tempCat = tempItem.filter((x: any) => x.CID == this.data.categoryID);
      
      if(tempCat.length == 0){
        tempItem = [];
        this.isdataFilter = true;
      }
      else{
        tempItem = tempCat;
      }
      
      if(tempCat.length > 0){
        tempItem = tempCat;
      }

      

    }

    //Sub Category 
    if(this.data.SubCategoryID > 0)
    {
      let subCatData = tempItem.filter((x: any) => x.SCID == this.data.SubCategoryID);
      
      if(subCatData.length == 0){
        tempItem = [];
        this.isdataFilter = true;
      }
      else{
        tempItem = subCatData;
      }
      
      if(subCatData.length > 0){
        tempItem = subCatData;
      }
    } 


    //Tags
    if (this.selectedTags.length > 0) {
          let tagArry = tempItem.filter((item: any) => {
              var tagArr = [];
              if (item.Tags) {
                  tagArr = (item.Tags).split(',');
              }
              for (let i = 0; i < this.selectedTags.length; i++) {
                  var existEle = tagArr.includes(this.selectedTags[i][0]);
                  if (existEle) {
                      return item;
                  }
              }
          });
    
          if (tagArry.length > 0){
            tempItem = tagArry;
          }
    }
    if (this.selectedStatus == 'active') {
      tempItem = tempItem.filter((x: any) => x.IsActive == true); // Show only active items
    } 
    else if (this.selectedStatus == 'inactive') {
      tempItem = tempItem.filter((x: any) => x.IsActive == false); // Show only inactive items
    }
    this.Items = tempItem
    if(this.selected.imp != 3){
      this.Items = this.Items.filter((item: any) => item.Imp == this.selected.imp)
    } 
    this.dataSource.data = this.Items
    this.exportToExcel = this.Items
    //this.dataSource.sort = this.sort;
    //this.dataSource.filterPredicate = this.createFilter();
    let tmpERP_Cfg = this.apiService.getCookie("ERP_Cfg");
    if(tmpERP_Cfg){
      this.tagData =  JSON.parse(tmpERP_Cfg);
    }
    this.totalValue = 0;
    for (let i = 0; i < this.Items.length; i++) {
      if(this.tagData[0].ValnMethod > 0){
        //this.totalValue = this.totalValue + this.Items[i].TotalValue
        this.totalValue = (this.totalValue + (this.tagData[0].ValnMethod == 1 ? this.Items[i].ValStdCost : this.tagData[0].ValnMethod == 2 ? this.Items[i].ValLPP : this.Items[i].ValHistAvg));
      }
    }
    this.saveFilters();
  }

  openReport() {
    let target: string = "_blank";
    if (this.isWeb == false) {
      target = "_self";
    }
    window.open('ERP/Report', target);
  }

  getData() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let data = [{
      StatusID: 1,
      StoreID: this.storeId,
      IsFromList: 1,
      changeType: this.changeType,
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'get',
      moduleID: 5,
      data: JSON.stringify(data)
    }];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successRespItem.bind(this), this.failureRespItem.bind(this));
  }

  //successResp - success  get handler
  successRespItem(res: any) {
    const isUpdateMode = this.changeType === 'UPDTPKG';
    this.changeType = '';
    this.SpinnerService.hide();
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
     
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let data = reponseData;
          let tempItems = data.Table1;
          
          // Process items for category and quantity calculations
          for (let x = 0; x < tempItems.length; x++) {
            if (tempItems[x].StoreBatches) {
              let tempData = JSON.parse(tempItems[x].StoreBatches)
              let tempQTY = tempData.filter((item: any) => item.SID == this.storeId)
              if (tempQTY.length > 0) {
                tempItems[x].CurrQty = Number(tempQTY[0].Q).toFixed(tempItems[x].SKUPrecision)
              } else {
                tempItems[x].CurrQty = 0
              }
            } else {
              tempItems[x].CurrQty = Number(tempItems[x].CurrQty).toFixed(tempItems[x].SKUPrecision)
            }
            tempItems[x].TotalValue = Number(tempItems[x].CurrQty) * Number(tempItems[x].DefStockRate)
            tempItems[x].ImpName = (tempItems[x].Imp == 0 ? 'Low' : (tempItems[x].Imp == 1 ? 'High' : 'Normal'))
            if (tempItems[x].CID > 0) {
              for (let i = 0; i < this.categories.length; i++) {
                if (tempItems[x].CID == this.categories[i].cid) {
                  if(this.categories[i].cnm){
                    tempItems[x].CN = this.categories[i].cnm;
                  }
                  else{
                    tempItems[x].CN = '';
                  }
                   let subCategory = this.categories.filter((A: any) => A.cid == tempItems[x].CID)
                   if(subCategory[0].sub){
                      let tempSubCat = subCategory[0].sub.filter((s: any) => s.sid == tempItems[x].SCID)
                      if (tempSubCat.length > 0) {
                        tempItems[x].SC = tempSubCat[0].snm
                      }
                      else {
                        tempItems[x].SC = ''
                      }
                   }
                   else{
                    tempItems[x].SC = ''
                   }                  
                }
              }
            }
            else {
              tempItems[x].CN = ''
            }

            tempItems[x].SCN = (!tempItems[x].CN ? '-' : tempItems[x].CN) + (tempItems[x].SC ? ' / ' : '') + (tempItems[x].SC ? tempItems[x].SC : '');
          }

          // Handle UPDATE mode - incremental updates
          if (isUpdateMode) {
            // Separate items to delete and items to update/add
            let itemsToRemove: any[] = [];
            let itemsToUpdate: any[] = [];
            
            for (let item of tempItems) {
              if (item.IsRemove === 1) {
                itemsToRemove.push(item.ItemID);
              } else {
                itemsToUpdate.push(item);
              }
            }
            
            // Delete removed items from IndexedDB
            if (itemsToRemove.length > 0) {
              this.apiService.deleteIDBItem('erp_inv', itemsToRemove);
            }
            
            // Update/add changed items in IndexedDB
            if (itemsToUpdate.length > 0) {
              this.apiService.updateIDBItem('erp_inv', itemsToUpdate);
            }
            
            // Reload all items from IndexedDB to refresh UI
            this.apiService.getIDB('erp_inv', (allItems: any[]) => {
              this.Items = allItems.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));
              this.refreshUIWithItems();
            });
          } else {
            // Normal mode - full refresh
            this.Items = tempItems.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));
            this.IncludeZeroqtyItms = this.Items;
            
            // If added first item, set the filter to 'All Stock Items'.
            this.cntTotalItems = this.Items.length;
            this.showItemList = this.cntTotalItems > 0 ? true : false;
            if (this.cntTotalItems == 1) {
              this.selected.stockType = "1";
            }
            
            // Store all items in IndexedDB
            this.apiService.setIDB('erp_inv', this.Items);
            
            this.refreshUIWithItems();
          }
        }
      }
    }
  }

  // Helper method to refresh UI with current items
  refreshUIWithItems() {
    if (this.Items && this.Items.length > 0) {
      for (let x = 0; x < this.Items.length; x++) {
        if (!this.Items[x].ImpName) {
          this.Items[x].ImpName = (this.Items[x].Imp == 0 ? 'Low' : (this.Items[x].Imp == 1 ? 'High' : 'Normal'));
        }
        if (!this.Items[x].SCN) {
          if (this.Items[x].CID > 0 && this.categories && this.categories.length > 0) {
            for (let i = 0; i < this.categories.length; i++) {
              if (this.Items[x].CID == this.categories[i].cid) {
                if(this.categories[i].cnm){
                  this.Items[x].CN = this.categories[i].cnm;
                }
                else{
                  this.Items[x].CN = '';
                }
                 let subCategory = this.categories.filter((A: any) => A.cid == this.Items[x].CID);
                 if(subCategory && subCategory.length > 0 && subCategory[0].sub){
                    let tempSubCat = subCategory[0].sub.filter((s: any) => s.sid == this.Items[x].SCID);
                    if (tempSubCat && tempSubCat.length > 0) {
                      this.Items[x].SC = tempSubCat[0].snm;
                    }
                    else {
                      this.Items[x].SC = '';
                    }
                 }
                 else{
                  this.Items[x].SC = '';
                 }                  
              }
            }
          }
          else {
            this.Items[x].CN = '';
          }
          this.Items[x].SCN = (!this.Items[x].CN ? '-' : this.Items[x].CN) + (this.Items[x].SC ? ' / ' : '') + (this.Items[x].SC ? this.Items[x].SC : '');
        }
      }
    }

    this.IncludeZeroqtyItms = this.Items;
    this.cntTotalItems = this.Items.length;
    this.showItemList = this.cntTotalItems > 0 ? true : false;
    
    // Filter out zero quantity items for display
    this.Items = this.Items.filter((x: any) => x.CurrQty > 0);
    this.copyItems = this.Items;

    this.dataSource = new MatTableDataSource(this.Items);
    this.exportToExcel = this.Items;
    
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.matSort;
    
    let tmpERP_Cfg = this.apiService.getCookie("ERP_Cfg");
    if(tmpERP_Cfg){
      this.tagData = JSON.parse(tmpERP_Cfg);
    }
    
    this.totalValue = 0;
    for (let i = 0; i < this.Items.length; i++) {
      if(this.tagData[0].ValnMethod > 0){
        this.totalValue = (this.totalValue + (this.tagData[0].ValnMethod == 1 ? this.Items[i].ValStdCost : this.tagData[0].ValnMethod == 2 ? this.Items[i].ValLPP : this.Items[i].ValHistAvg));
      }
    }
    
    this.getTagSearchData(2);
    this.filterStockItems();
  }

  //failureResp - failure handler
  failureRespItem(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }


  getAllConfig() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let data: any = []

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'getConfig',
      moduleID: 6,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successRespGet.bind(this), this.failureRespGet.bind(this));
  }

  //failureResp - failure handler
  failureRespGet(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  successRespGet(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          let configData = reponseData.Table2;
          if (configData[0].Stores) {
            this.storeList = JSON.parse(configData[0].Stores)
            this.cntAllStores = this.storeList.length;
            // console.log('Stores', this.storeList);
            this.UnitList = JSON.parse(configData[0].Units)
            this.hsnList = JSON.parse(configData[0].HSNSAC)
            if(configData[0].ItemCategories){
              this.categories = JSON.parse(configData[0].ItemCategories)
            }

            // For Limited Store Rights
            let myStores: any = [];
            if(this.jarvisData[0].UserID != this.agencyData[0].AdminUserID) {
              for(let i: number = 0; i < this.storeList.length; i++){
                if(this.storeList[i].UIDs){
                  let selectedUsers = String(this.storeList[i].UIDs).split(",");
                  for(let j: number = 0; j < selectedUsers.length; j++){
                    if(selectedUsers[j] == this.jarvisData[0].UserID){
                      myStores.push(this.storeList[i]);
                    }
                  }                
                }
                else{
                  myStores.push(this.storeList[i]);
                }
              }
              if(myStores.length != this.storeList.length){
                const currStore = myStores.find((s: any) => s.StrID == this.storeId);
                if (currStore) {
                  this.storeId = currStore.StrID;
                  this.storeName = currStore.sNm;
                } else {
                  this.storeId = myStores.length > 0 ? myStores[0].StrID : 0;
                  this.storeName = myStores.length > 0 ? myStores[0].sNm : '';
                }
                this.allStoreRights = false;
                this.zeroQtyItems = false;
                this.storeList = myStores;
              }
            }
            
            // this.categories = JSON.parse(configData[0].ItemCategories)
            // this.storeId = this.storeList[0].StrID
            // this.storeName = this.storeList[0].sNm;
            if (myStores.length > 0 || this.jarvisData[0].UserID == this.agencyData[0].AdminUserID) {
              this.apiService.getIDB('erp_inv', (allItems: any[]) => {
                this.Items = allItems.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));
                if (this.Items.length > 0) {
                  this.changeType = 'UPDTPKG';
                }
                this.getData()
              });
            }
            // console.log(this.categories)

          }
        }

      }
    }
  }


  //depleted items
  filterDepleted() {
    this.typeFilter(this.filter);
    return;


    let tempdata = this.Items
    if (this.depletedItems) {
      let tempItems = tempdata.filter((x: any) => x.CurrQty < x.MinStockQty)
      this.Items = tempItems
      this.Items = this.Items.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName))

      this.dataSource.data = this.Items
      this.exportToExcel = this.Items
      //this.dataSource.sort = this.sort;
      //this.dataSource.filterPredicate = this.createFilter();
    }
    else {
      this.Items = this.copyItems
      this.Items = this.Items.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName))

      this.dataSource.data = this.Items
      this.exportToExcel = this.Items
      //this.dataSource.sort = this.sort;
      // this.dataSource.filterPredicate = this.createFilter();
    }
  }

  //depleted items
  filterIncludeZeroqty() {
    this.typeFilter(this.filter);
    return;

    if (this.zeroQtyItems) {
      this.IncludeZeroqtyItms = this.IncludeZeroqtyItms.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName))
      this.dataSource.data = this.IncludeZeroqtyItms;
      this.exportToExcel = this.IncludeZeroqtyItms;
      this.Items = this.IncludeZeroqtyItms;
      //this.dataSource.sort = this.sort;
      //this.dataSource.filterPredicate = this.createFilter();
    }
    else {
      this.Items = this.copyItems;
      this.Items = this.Items.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));

      this.dataSource.data = this.Items;
      this.exportToExcel = this.Items;
      //this.dataSource.sort = this.sort;
      //this.dataSource.filterPredicate = this.createFilter();
    }
  }

  DeleteItem(obj: any) {

    var r = confirm("Are you sure you want to delete this item?");
    if (r == true) {

      let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")

      //Validation
      if (obj == "") {
        this.apiService.successAlert('Please select an item.');
        return;
      }

      else {
        var tempData = [{
          'ItemID': obj.ItemID
        }]

        let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: MyLastSyncDT,
          isWeb: true,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          actionType: 'Delete',
          moduleID: 5,
          data: JSON.stringify(tempData)
        }];

        this.apiService.sendChange(myParams, this.successDelete.bind(this), this.failureDelete.bind(this));
      }
    }
    else {
      return
    }
  }
  //failureResp - failure handler
  failureDelete(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  successDelete(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          let agencyConfig: any = this.apiService.getCookie('Cfg_AgnCfg');
          if (agencyConfig) {
            agencyConfig = JSON.parse(agencyConfig);
            if (agencyConfig && agencyConfig.length > 0 && reponseData.Table[0].Billable) {
              agencyConfig[0].Billables = reponseData.Table[0].Billable;
            }
            this.apiService.setCookie('Cfg_AgnCfg', JSON.stringify(agencyConfig));
          }
          this.changeType = 'UPDTPKG';
          this.getData();
          this.apiService.setCookie("MyLastSyncDT", '');
        }
      }

    }
  }

  //common search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.saveFilters();
  }

  selectStore(content: any) {
    //this.modalReference = this.modalService.open(content);
    //If can change store
    this.modalReference = this.modalService.open(SelectStoreComponent, { backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.StoreID = this.storeId;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    if(!this.allStoreRights)  {
      this.modalReference.componentInstance.AllOption = 0; 
      this.modalReference.componentInstance.isShowAllOption = false;
    }  
    
    this.modalReference.result.then((result: any) => {
      if (result && result.length > 0) {
        this.storeId = result[0].StrID;
        this.storeName = result[0].sNm;
        // Store changed - need full refresh with all items
        this.changeType = '';
        this.getData();
      }
    });

  }

  openQty(content: any, strBatch: any, id: number) {
    let item = [];
    if (this.zeroQtyItems) {
      item = this.IncludeZeroqtyItms.filter((x: any) => x.ItemID == id);
    } else {
      item = this.Items.filter((x: any) => x.ItemID == id);
    }
    if(item.length > 0){
      this.itemName = item[0].ItemName;
    }
    
    if ((this.storeId == 0) && (!strBatch)) {
      this.getProductDetail(id, content);
    }

    if (strBatch) {

      this.modalReference = this.modalService.open(content, { windowClass: 'qty-edit', backdrop: 'static', keyboard: false });
      this.selectedStoreQty = [];

      this.tmpstrQty = JSON.parse(strBatch);
      let obj = { name: '', qty: '0', ItemID: 0, StrID: 0, isEdit: false, unit: '', prec: 0 };

      // for(let s = 0; s < this.storeList.length; s++) {
      //   for(let q = 0; q < this.tmpstrQty.length; q++) {
      //     let tmpArr = this.selectedStoreQty.filter((x: any) => { return x.StrID == this.storeList[s].StrID });
      //     obj = { name: '', qty: '0', ItemID: 0, StrID: 0, isEdit: false, unit: '', prec: 0 };

      //     if((tmpArr.length == 0) && (this.storeList[s].StrID == this.tmpstrQty[q].SID)) {
      //       if(this.storeList[s].StrID === this.tmpstrQty[q].SID) {
      //         obj.name = this.storeList[s].sNm;
      //         obj.qty = Number(this.tmpstrQty[q].Q).toFixed(item[0].SKUPrecision);
      //         obj.ItemID = id;
      //         obj.StrID = this.storeList[s].StrID;
      //         obj.unit = item[0].SKU;
      //         obj.prec = item[0].SKUPrecision;
      //         this.selectedStoreQty.push(obj);
      //       }
      //     }  
      //     else {
      //       obj.name = this.storeList[s].sNm;
      //       obj.qty = '0';  
      //       obj.ItemID = id;
      //       obj.StrID = this.storeList[s].StrID;
      //       obj.unit = item[0].SKU;
      //       obj.prec = item[0].SKUPrecision;
      //       this.selectedStoreQty.push(obj);
      //     }
      //   }
      // }

      // for(let s = 0; s < this.storeList.length; s++) {
      //   for(let q = 0; q < this.tmpstrQty.length; q++) {
      //     obj = { name: '', qty: '0', ItemID: 0, StrID: 0, isEdit: false, unit: '', prec: 0 };
      //     if(this.storeList[s].StrID == this.tmpstrQty[q].SID) {
      //       obj.name = this.storeList[s].sNm;
      //       obj.qty = Number(this.tmpstrQty[q].Q).toFixed(item[0].SKUPrecision);
      //       obj.ItemID = id;
      //       obj.StrID = this.storeList[s].StrID;
      //       obj.unit = item[0].SKU;
      //       obj.prec = item[0].SKUPrecision;
      //       this.selectedStoreQty.push(obj);
      //       break;
      //     }  
      //     else {
      //       obj.name = this.storeList[s].sNm;
      //       obj.qty = '0';  
      //       obj.ItemID = id;
      //       obj.StrID = this.storeList[s].StrID;
      //       obj.unit = item[0].SKU;
      //       obj.prec = item[0].SKUPrecision;
      //       this.selectedStoreQty.push(obj);
      //       break;
      //     }
      //   }
      // }

      for (let s = 0; s < this.storeList.length; s++) {
        let stores = this.storeList[s];
        let currStore = $.grep(this.tmpstrQty, function (o: any) { return o.SID == stores.StrID });
        let storeQty = 0;
        if (currStore.length > 0) {
          storeQty = currStore[0].Q;
        }

        this.selectedStoreQty.push({
          name: stores.sNm,
          qty: Number(storeQty).toFixed(item[0].SKUPrecision),
          ItemID: id,
          StrID: stores.StrID,
          unit: item[0].SKU,
          prec: item[0].SKUPrecision
        });
      }

      this.selectedStoreQty = this.selectedStoreQty.sort((a: any, b: any) => a.name.localeCompare(b.name))
    }
  }


  //qty with prcn
  enterQty = (s: any) => {
    s.qty = this.CmnService.PrecisionwiseValue(s.qty, s.prec)
  }
  prcnQty(obj:any) {
    obj.qty = Number(obj.qty).toFixed(obj.prec)
  }
  openTransaction(id: any) {
    this.modalReference = this.modalService.open(TransactionComponent, { windowClass: "transactionMdl", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.isReceive = id;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
  }

  saveReconcile(obj: any) {
    //obj.isEdit = false;

    if(obj.qty == "" || String(obj.qty) == "undefined"){
      this.apiService.successAlert("Please enter a valid quantity.");
      return;
    }

    let currStore = this.tmpstrQty.find((o:any) => o.SID == obj.StrID);
    if (currStore) {
      let currQty = currStore.Q ? Number(currStore.Q) : 0;
      if (currQty == obj.qty) {
        this.apiService.successAlert("This transaction cannot be processed as the current quantity is the same as the new quantity.");
        return;
      }
    }

    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");

    let data = [{
      'ItemID': obj.ItemID,
      'StoreID': obj.StrID,
      'NewQty': obj.qty
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'Reconcile',
      moduleID: 5,
      data: JSON.stringify(data)
    }];
    this.apiService.sendChange(myParams, this.successReconcile.bind(this, obj), this.failureReconcile.bind(this, obj));

  }

  //failureResp - failure handler
  successReconcile(obj: any, res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          obj.isEdit = false;
          // Reconcile updated item quantity - use UPDATE to get only affected item
          this.changeType = 'UPDTPKG';
          this.getData();
          this.tmpstrQty.forEach(function (o:any) {
            if (o.SID == obj.StrID) {
              o.Q = obj.qty;
            }
          })
        }
      }
    }
  }

  //successResp - success get handler
  failureReconcile(obj: any, res: any) {
    if (res.error) {
      console.log(res.message);
    }
  }

  closeStrBtcModal() {	
    this.isBatchShow = false;
    let toSendData = {'isFromStockReco': this.isBatchShow , 'batchList': this.batchList}
    this.dataSer.updateRecoBatchData(toSendData);

    let toSendBatchData = {'itemID': this.currItemID, 'batchList': this.resetBatchData, 'oldBatchList': this.oldBatchList,}
    // let toSendData = {'itemID': this.itemID, 'batchList': this.batchList, 'oldBatchList': this.oldBatchList, 'sumBatchesQty': this.batchTotalQty, 'isShowEdt': this.isShowEdt}

    this.dataSer.updateBathesData(toSendBatchData)
    this.modalReference.close();	
  }	
  
 // Reconsilation
 openStrBatchQtyMdl(content: any, strBatch: any, id: number, recoBatches: any) {

  this.batchList = [];

  this.batchTotalQty = 0;
  this.storeTotalQty = 0;

  this.isBatchShow = true;
  if(recoBatches)
  {
    this.batchList = JSON.parse(recoBatches);
  }
  let toSendData = {'isFromStockReco': this.isBatchShow , 'batchList': this.batchList}
  this.dataSer.updateRecoBatchData(toSendData);
  
  let item = [];
  if (this.zeroQtyItems) {
    item = this.IncludeZeroqtyItms.filter((x: any) => x.ItemID == id);
  } else {
    item = this.Items.filter((x: any) => x.ItemID == id);
  }
  if(item.length > 0){
    this.itemName = item[0].ItemName;
  }
  
  if ((!strBatch) || (!recoBatches)) {
    this.getProductDetail(id, content);
  }
  else {
    this.modalReference = this.modalService.open(content, { windowClass: 'qty-edit-batches', backdrop: 'static', keyboard: false });
    // this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.selectedStoreQty = [];

    this.tmpstrQty = JSON.parse(strBatch);
    let obj = { name: '', qty: '0', ItemID: 0, StrID: 0, isEdit: false, unit: '', prec: 0 };

    for (let s = 0; s < this.storeList.length; s++) {
      let stores = this.storeList[s];
      let currStore = $.grep(this.tmpstrQty, function (o: any) { return o.SID == stores.StrID });
      let storeQty = 0;
      if (currStore.length > 0) {
        storeQty = currStore[0].Q;
      }

      this.selectedStoreQty.push({
        name: stores.sNm,
        qty: Number(storeQty).toFixed(item[0].SKUPrecision),
        ItemID: id,
        StrID: stores.StrID,
        unit: item[0].SKU,
        prec: item[0].SKUPrecision
      });
    }

    this.selectedStoreQty = this.selectedStoreQty.sort((a: any, b: any) => a.name.localeCompare(b.name))
  }
}
  //Reconcilation - save 
  fn_StrBatchesReconcile() {
    // Get Batches Data for perticular Item
     this.dataSer.batches.subscribe((value: any) => {
         if(value.batchList) {
           if(value.batchList.length > 0){
             this.batchList  = value.batchList;
           }
         }
     });
 
     this.batchTotalQty = 0;
     this.storeTotalQty = 0;
     for (let i = 0; i < this.batchList.length; i++) {
      this.batchTotalQty = Number(this.CmnService.PrecisionwiseValue((Number(this.batchTotalQty) + Number(this.batchList[i].Q)).toFixed(this.itemPrcn), this.itemPrcn));
      this.batchTotalQty = Number(this.CmnService.PrecisionwiseValue(this.batchTotalQty.toFixed(this.itemPrcn), this.itemPrcn));
     }	
 
     this.tempStrQty = [];

     let finalStoreList = this.selectedStoreQty.filter((x: any) => x.qty > 0);
     for (let i = 0; i < finalStoreList.length; i++) {	
      this.tempStrQty.push({
          SID: finalStoreList[i].StrID,
          Q: Number(finalStoreList[i].qty).toFixed(finalStoreList[i].prec),
      });
    }	
   
     for (let i = 0; i < this.tempStrQty.length; i++) {	
      // let strQty = this.CmnService.PrecisionwiseValue(this.tempStrQty[i].Q, this.itemPrcn)
      // this.storeTotalQty = Number(this.storeTotalQty) + Number(strQty);
      // let strQty = this.CmnService.PrecisionwiseValue(this.tempStrQty[i].Q, this.itemPrcn)
      this.storeTotalQty = Number(this.CmnService.PrecisionwiseValue(String(this.storeTotalQty), this.itemPrcn)) + Number(this.CmnService.PrecisionwiseValue(this.tempStrQty[i].Q, this.itemPrcn));
     }	

     if (Number(this.batchTotalQty.toFixed(this.itemPrcn)) != Number(this.storeTotalQty.toFixed(this.itemPrcn))) {
         this.apiService.successAlert("Please ensure that the total quantity of batches matches the total quantity of stores.");
         return
     }
   
     let data = [{
       'ItemID': this.currItemID,
       'Stores': this.tempStrQty ? JSON.stringify(this.tempStrQty) : [],
       'Batches': this.batchList ? JSON.stringify(this.batchList) : []
       
     }];
     let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");
     let myParams = [{
       myUserID: this.jarvisData[0].UserID,
       myToken: this.jarvisData[0].WebToken,
       forAgencyID: this.jarvisData[0].AgencyIDs,
       myAgencyIDs: this.jarvisData[0].AgencyIDs,
       myLastSyncDT: MyLastSyncDT,
       isWeb: true,
       ForERPAgencyID: this.agencyData[0].ERPAgencyID,
       actionType: 'setReconcileItemAllStores',
       moduleID: 5,
       data: JSON.stringify(data)
     }];
     this.apiService.sendChange(myParams, this.successStrBatchReconcile.bind(this), this.failureStrBatchReconcile.bind(this));
 
  }
 
  //failureResp - failure handler
  successStrBatchReconcile(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          this.getData();
          this.batchList = [];
          this.dataSer.updateBathesData(this.batchList)
          // let toSendData = {'itemID': this.itemID, 'batchList': this.batchList, 'oldBatchList': this.oldBatchList, 'sumBatchesQty': this.batchTotalQty, 'isShowEdt': this.isShowEdt}
          // this.dataSer.updateBathesData(toSendData)
          this.batchTotalQty = 0;
          this.storeTotalQty = 0;
          this.closeStrBtcModal();
        }
      }
    }
  }

  //successResp - success get handler
  failureStrBatchReconcile( res: any) {
    if (res.error) {
      console.log(res.message);
    }
  }

  // exportToExcel() {
  //   const ws: xlsx.WorkSheet =
  //     xlsx.utils.table_to_sheet(this.epltable.nativeElement);
  //   const wb: xlsx.WorkBook = xlsx.utils.book_new();

  //   xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
  //   xlsx.writeFile(wb, 'Stock.xlsx');
  // }

  //getProductDetail() - Get Product Details
  getProductDetail(id: number, content: any) {

    let data = [{
      productID: id
    }]

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 4,
      data: JSON.stringify(data)
    }];

    return this.apiService.getData(myParams, this.successResp.bind(this, content, id), this.failureResp.bind(this));
  }

  //failureResp - failure handler
  failureResp(res: any) {

    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

 //successResp - success  get handler
 successResp(content: any, id: number, res: any) {
  if (res.error) {
    console.log(res.message);
  }
  else {
    if (res) {
      var reponseData = JSON.parse(res.updatePackage);
      if (reponseData.Table[0].ErrCode == 1) {
        alert(reponseData.Table[0].ErrMsg);
        // this.router.navigateByUrl('/Stock');
      }
      else {
        let productData = reponseData.Table[0];

        let StoreBatches = productData.StoreBatches;
        let recoBatches = productData.Batches;
        this.totalStkQty = Number((productData.CurrQty).toFixed(productData.SKUPrecision));
        this.totalStkUnit = productData.DU;
        this.itemPrcn = productData.SKUPrecision;
        this.currItemID = productData.ItemID;
        if(productData.BatchType == 1 ||  productData.BatchType == 2)
        {
          if(recoBatches && recoBatches != '[]' && recoBatches != '')
          {
            var tempRecoBatchData = JSON.parse(recoBatches);
            this.resetBatchData = tempRecoBatchData
            this.oldBatchList = [];
            let tempoldBatchList = tempRecoBatchData.filter((b: any) => (Number(b.Q) == 0));
            if(tempoldBatchList.length > 0){
              this.oldBatchList = tempoldBatchList;
            }
          
            let tmpBatchList = tempRecoBatchData.filter((b: any) => (Number(b.Q) > 0));
            if(tmpBatchList.length > 0){
              this.newBatchList = tmpBatchList;
            }
            else{
                this.newBatchList = '[]';
            }
               
            let tmpBatchDataList = {
              oldBatchList: this.oldBatchList,
              Batches:  this.newBatchList,
              ItemID: productData.ItemID,
              BatchType: productData.BatchType,
              SKU: productData.DU,
              Prcsn: productData.SKUPrecision
            };
            this.dataSer.updateByProduct(tmpBatchDataList);

            // let toSendData = {'itemID': this.currItemID, 'batchList': this.newBatchList, 'oldBatchList': this.oldBatchList, 'sumBatchesQty': this.batchTotalQty, 'isShowEdt': false}
            // this.dataSer.updateBathesData(toSendData)
          }
          else{
            let tmpBatchDataList = {
              oldBatchList: '[]',
              Batches:  '[]',
              ItemID: productData.ItemID,
              BatchType: productData.BatchType,
              SKU: productData.DU,
              Prcsn: productData.SKUPrecision
            };
            this.dataSer.updateByProduct(tmpBatchDataList);
            // this.batchList = [];
            // this.dataSer.updateBathesData(this.batchList)
            // let toSendData = {'itemID': this.currItemID, 'batchList': '[]', 'oldBatchList': '[]', 'sumBatchesQty': this.batchTotalQty, 'isShowEdt': false}
            // this.dataSer.updateBathesData(toSendData)
          }
          
          this.isRecoBatchDivShow = true;
          this.openStrBatchQtyMdl(content, StoreBatches, id, recoBatches);
        }
        else{
          this.openQty(content, StoreBatches, id);
        }
      }
    }
  }
}


  opentagSearch(content: any) {
   // this.selectedTags = [];
   // this.itemTag.search = '';
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'tagClass', backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    });
  }


  chagetagValue() {

    // let temptag = this.tag.filter((x: any) => x == this.Items.tag);
    // if (temptag.length > 0) {
    // } else {
    //   this.Items.tag = "";
    // }

    // if (this.Items.tag == null || this.Items.tag == undefined || this.Items.tag == 0) {
    //   alert("Please Select Tag");
    // } else {
    if (this.itemTag.search != '') {
      let temptag = this.tag.filter((x: any) => x == this.itemTag.search);
      if (temptag.length > 0) {

        let temptag1 = this.selectedTags.filter((x: any) => x == this.itemTag.search);
        if (temptag1.length == 0) {
          this.selectedTags.push(temptag);
        }
        // this.itemTag.search = "";
      }
    }

    //}
  }

  getTagSearchData(id: number) {

    if ((this.itemTag.search == "") && (id == 1)) {
      this.apiService.successAlert("Please select a tag.");
      return;
    } else {
      let temptag = this.tag.filter((x: any) => x == this.itemTag.search);
      if (temptag.length > 0) {

        let temptag1 = this.selectedTags.filter((x: any) => x == this.itemTag.search);
        if (temptag1.length == 0) {
          this.selectedTags.push(temptag);
          this.tag = this.tag.filter((b: any) => b != this.itemTag.search);
        }
        this.itemTag.search = "";
      }
       else {
         this.itemTag.search = "";
       }
    }

    if ((id == 2) && (this.itemTag.search != "")) {
      let temptag = this.tag.filter((x: any) => x == this.itemTag.search);
      if (temptag.length > 0) {

        let temptag1 = this.selectedTags.filter((x: any) => x == this.itemTag.search);
        if (temptag1.length == 0) {
          this.selectedTags.push(temptag);
          this.tag = this.tag.filter((b: any) => b != this.itemTag.search);
        }
        // this.itemTag.search = "";
      }
      // else {
      //   this.itemTag.search = "";
      // }
    }
  }

  removeTagSearch = (index: any) => {
    let tmpTag = this.selectedTags.splice(index, 1).join(', ');
    //this.selectedTags.splice(index, 1);
    this.tag.push(tmpTag);
    this.tag = this.tag.sort((a: any, b: any) => a.localeCompare(b));
  }

  tagSearchItem() {
    this.getTagSearchData(2);
    let filteredItems: any = [];

    this.Items.forEach((element: any) => {
      if (!Array.isArray(element.Tags)) {
        if (element.Tags != '') {
          element.Tags = element.Tags.split(',');
        }
      }
    });

    if (this.selectedTags.length > 0) {
      this.selectedTags.forEach((a: any) => {
        this.Items.forEach((b: any) => {
          if (b.Tags.length > 0) {
            b.Tags.forEach((c: any) => {
              if (a == c) {
                filteredItems.push(b);
              }
            });
          }
        });
      });
    } else {
      filteredItems = this.Items;
    }

    // this.dataSource = new MatTableDataSource(filteredItems);
    // console.log("tags",filteredItems);

    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.matSort;

    // this.modalReference.close();

  }
// filter search Category & Sub Category
filterApply() {
  this.getTagSearchData(2);
  this.typeFilter(this.filter);
  if (this.modalReference){
    this.modalReference.close();
  }
  return;

  
  let tempFilData = this.copyItems;
  if(this.data.categoryID > 0)
  {
    let tempCat = tempFilData.filter((x: any) => x.CategoryID == this.data.categoryID);
    if(tempCat.length> 0){
      tempFilData = tempCat;
    }
  }
  if(this.data.SubCategoryID > 0)
  {
    let subCatData = tempFilData.filter((x: any) => x.SCID == this.data.SubCategoryID);
    if(subCatData.length > 0){
      tempFilData = subCatData;
    }
  } 
  if (this.selectedTags.length > 0) {
      let tagArry = tempFilData.filter((item: any) => {
          var tagArr = [];
          if (item.Tags) {
              tagArr = (item.Tags).split(',');
          }
          for (let i = 0; i < this.selectedTags.length; i++) {
              var existEle = tagArr.includes(this.selectedTags[i][0]);
              if (existEle) {
                  return item;
              }
          }
      });

      if (tagArry.length > 0){
          tempFilData = tagArry;
      }
  }
  this.Items = tempFilData;
  this.dataSource = new MatTableDataSource(tempFilData);
  this.exportToExcel = tempFilData;
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.matSort;
  if (this.modalReference){
    this.modalReference.close();
  }
}

//filterSubCategory() - Get sub category List from category - Case cading
 filterCategory = () => {

  this.subCategoryList = [];
 
  let catID: number = this.data.categoryID;
  
  let subCat: any = this.categories.filter(x => x.cid == catID);
  if(subCat.length > 0){
    if (subCat[0].sub) {
        this.subCategoryList = (subCat[0].sub);
    }
    else {
        this.data.SubCategoryID = "0";
        this.data.subCategory = '';
    }
  }
  this.filterApply();
  return;
}

//select subCategory
 filterSubCategory = () => {
  setTimeout(() => {
  let tempsubCat: any = [];
 
  if (this.data.subCategory) {
    let tempsubCat: any = [];
    tempsubCat = this.subCategoryList.filter((x: any) => x.snm == this.data.subCategory)
  
    if (tempsubCat.length > 0) {
      this.data.SubCategoryID = tempsubCat[0].sid
    }
    else {
      this.apiService.successAlert("Please configure item categories.")
      this.data.subCategory = '';
      this.data.SubCategoryID = 0;

    }
  }
  this.filterApply();
}, 200);
}



backToHomeBtn() {
  window.location.href = "https://biziverse.com/main.html#/home";
}
//export to excel
exportToExcelActivities() {
  var html = "";
  // Title
  html += "<table><tr>";
  html += "<th style='text-align: left;'>Stock</th>"
  html += "</table></tr>"; 

  html += "<table><tr></table></tr>";
  html += "<table><tr>";
  var usage = this.filter == 0 ? 'All' : this.filter == 1 ? 'Products' : this.filter == 2 ? 'Materials' : this.filter == 5 ? 'Spares' : this.filter == 4 ? 'Assemblies' : 'All';
  var zero = (this.depletedItems == false && this.zeroQtyItems == false) ? '' : this.depletedItems == true ? 'Show Depleted Items' : 'Include Zero Qty Items'
  html += "<p><b>View : </b>" + usage + (zero != '' ? '<b>, ' + zero + ' :</b>  Yes' : '') + "</p>"
  html += "</table></tr>";

  html += "<table><tr>";
  var strHeader = ""
  strHeader += "<th style='text-align: left;'>Item</th>";
  strHeader += "<th style='text-align: left;'>Code</th>";
  strHeader += "<th style='text-align: left;'>Category</th>";
  strHeader += "<th style='text-align: right;'>Qty</th>";
  strHeader += "<th style='text-align: left;'>Unit</th>";
  if (this.isRateView) {
    strHeader += "<th style='text-align: right;'>Rate</th>";
    strHeader += "<th style='text-align: left;'>Value</th>";
  }
  

  strHeader += "</tr>"
  html += strHeader;
  var body = "";
  this.exportToExcel.forEach((item:any, key:any) => {
    let itemValue: number = 0;
    itemValue = (this.ValnMethod == 1 ? item.ValStdCost : (this.ValnMethod == 2 ? item.ValLPP : (this.ValnMethod == 3 ? item.ValHistAvg : 0)))
    body += "<tr>";
    body += "<td style='text-align: left;'>" + item.ItemName + "</td>";
    body += "<td style='text-align: left;'>" + item.ItemCode + "</td>";
    body += "<td style='text-align: left;'>" + (item.SCN ? item.SCN : '-') + "</td>";
    body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" +  item.CurrQty + "</td>";
    body += "<td style='text-align: left;'>" +  item.SKU + "</td>";
    if (this.isRateView) {
      body += "<td style='text-align: right;'>" +  (this.myCurrency.code == 'INR' ? Number(item.DefStockRate).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,') : Intl.NumberFormat('en-US').format(item.DefStockRate)) + "</td>";
      body += "<td style='text-align: right;'>" +  (this.myCurrency.code == 'INR' ? Number(itemValue).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,') : Intl.NumberFormat('en-US').format(itemValue)) + "</td>";  
    }
    
  body += "</tr>";
  })
  html += body;
  html += "</table>";
  this.tableToExcel(html, 'Sheet1', 'Stock');
}

// Import Item Modal Open
 importItems(content: any) {
  if(this.isEnableBatches){
    alert('Please note that items having batches cannot be imported from Excel.')
    this.modalReference = this.modalService.open(ImportItemsComponent,{ ariaLabelledBy: 'modal-basic-title', windowClass: 'modalWidthSmall', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.result.then((result: any) => {
      if (result && result.action == 'Done') {
        this.getData();
      }
    });
  }
  else{
    this.modalReference = this.modalService.open(ImportItemsComponent,{ ariaLabelledBy: 'modal-basic-title', windowClass: 'modalWidthSmall', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.result.then((result: any) => {
      if (result && result.action == 'Done') {
        this.getData();
      }
    });
  }
}

  //changeQty() - Change Qty
  changeQty(ind: number){
    if(ind > -1) {
      this.selectedStoreQty[ind].isEdit = !this.selectedStoreQty[ind].isEdit;
      if(this.selectedStoreQty[ind].qty == 0){
          this.selectedStoreQty[ind].qty = "";
      };
    }
  }

  //changeQty() - Change Qty
  changeBatchQty(ind: number){
    if(ind > -1) {
      this.batchList[ind].isBatchEdit = !this.batchList[ind].isBatchEdit;
      if(this.batchList[ind].Q == 0){
          this.batchList[ind].Q = "";
      };
    }
  }

  changeStore(){
    let store = this.storeList.find((store: any) => store.StrID == this.storeId);
    if(store){
      this.storeId = store.StrID;
      this.storeName = store.sNm;
    }
    else{
      this.storeId = 0;
      this.storeName = "All Stores";
    }
    this.getData();
  }

  filterStockItems(){
    switch (Number(this.selected.stockType)) {
      case 0:
        this.depletedItems = false;
        this.zeroQtyItems = false;
        break;
      case 1:
        this.depletedItems = false;
        this.zeroQtyItems = true;
        break;
      case 2:
        this.depletedItems = true;
        this.zeroQtyItems = true;
        break;
      }
      this.typeFilter(this.filter);
  }

  getFilterCount() {
    let count = 0;
    // if (this.storeId && this.storeId != 0) count++;
    if (this.data.categoryID && this.data.categoryID != '0') count++;
    if (this.data.SubCategoryID && this.data.SubCategoryID != '0') count++;
    if (this.selected.stockType != 1) count++;
    if (this.selected.imp != 3) count++;
    if (this.selectedStatus != 'all') count++;
    if (this.filter != 0) count++;
    if (this.selectedTags && this.selectedTags.length > 0) count += this.selectedTags.length;
    return count;
  }

  saveFilters() {
    const filters = {
      filter: this.filter,
      storeId: this.storeId,
      categoryID: this.data.categoryID,
      SubCategoryID: this.data.SubCategoryID,
      stockType: this.selected.stockType,
      imp: this.selected.imp,
      selectedStatus: this.selectedStatus,
      selectedTags: this.selectedTags,
      search: this.search,
      itemTagSearch: this.itemTag.search
    };
    localStorage.setItem('stockFilters', JSON.stringify(filters));
  }

  loadFilters() {
    const saved = localStorage.getItem('stockFilters');
    if (saved) {
      const filters = JSON.parse(saved);
      if (filters.filter !== undefined) this.filter = filters.filter;
      if (filters.storeId !== undefined) this.storeId = filters.storeId;
      if (filters.categoryID !== undefined) this.data.categoryID = filters.categoryID;
      if (filters.SubCategoryID !== undefined) this.data.SubCategoryID = filters.SubCategoryID;
      if (filters.stockType !== undefined) this.selected.stockType = filters.stockType;
      if (filters.imp !== undefined) this.selected.imp = filters.imp;
      if (filters.selectedStatus !== undefined) this.selectedStatus = filters.selectedStatus;
      if (filters.selectedTags !== undefined) this.selectedTags = filters.selectedTags;
      if (filters.search !== undefined) this.search = filters.search;
      if (filters.itemTagSearch !== undefined) this.itemTag.search = filters.itemTagSearch;
    }
  }

  clearAllFilters() {
    this.filter = 0;
    // this.storeId = 0;
    this.data.categoryID = '0';
    this.data.SubCategoryID = '0';
    this.selected.stockType = 1;
    this.selected.imp = 3;
    this.selectedStatus = 'all';
    this.selectedTags = [];
    this.search = '';
    this.itemTag.search = '';
    
    this.ItemNameFilter.setValue('');
    this.ItemCodeFilter.setValue('');
    this.CategoryFilter.setValue('');
    this.ImpFilter.setValue('');
    this.CurrQtyFilter.setValue('');
    this.SKUFilter.setValue('');
    this.DefStockRateFilter.setValue('');
    
    this.filterStockItems();
    this.refreshUIWithItems();
  }

  removeTagSearchNew(i: number){
    this.removeTagSearch(i);
    this.filterApply();
  }

  toggleSearch() {
    this.show.search = !this.show.search;
    if(this.show.search){
      setTimeout(() => {
        this.inputStockSearch.nativeElement.focus();
      }, 0);
    }
    else{
      setTimeout(() => {
        this.inputStockSearch.nativeElement.blur();
      }, 0);
    }
  }

  toggleFilters() {
    this.show.filters = !this.show.filters;
  }

  openUpgradeForInventory(id: number, from?: string) {
      if (from) {
        let goToURL = "https://biziverse.com/main.html#/Upgrade?i=" + id + "&z=1&h=" + from;
          if (this.isWeb == false) {
              window.location.href = goToURL;
              return;
          }
          else {
               window.open(goToURL, '_blank', 'height = 750, width = 1050,resizable=false, menubar=no');
          }
      }
      else {
        window.location.href = "https://biziverse.com/main.html#/Upgrade?i=" + id + "&z=1";
      }
  }

  // Open Help Page
  openHelpPage(id: any) {
    this.CmnService.openModulHelp(id, this.isWeb);
  }

  openTrngModal = () => {
    this.dataSer.trainingVideoActions('active', 12);
    this.modalReference = this.modalService.open(ModuleTrainingComponent, { windowClass: "modal-suggest-profile", backdrop: 'static', keyboard: false });
  }
}

  export interface category {
  cid: number;
  cnm: string;
  sub: any[];
}

export interface subCategory {
  sid: number;
  snm: string;
}



